module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/babel-runtime/core-js/symbol.js
// module id = 1787
// module chunks = 0